import gsap from 'gsap';
import scrollTrigger from './gsap-public/minified/ScrollTrigger.min.js';
jQuery(function ($) {


    // document.addEventListener('facetwp-loaded', function() {
    //     document.querySelector('.facetwp-template').classList.add('facet-refresh');
    // })

    gsap.registerPlugin(scrollTrigger);


    $('body').addClass('animations-loaded');




    function animate() {

        // items that fade in when they enter the viewport
        // const fadeIn = gsap.utils.toArray('.integrations-block-outer, .wp-block-cover__image-background, .wp-block-cover__background,  .site-footer');

        // items that fade up and in when they enter the viewport
        const fadeUpIn = gsap.utils.toArray('.entry-content > .wp-block-image, .entry-content > .wp-block-group, .entry-content > section , .entry-content > .wp-block-heading, .entry-content > p, .carousel-slide__inner, .carousel-slide__inner__content__bottom .carousel-slide__inner__image .logo, .cta-block, .prefooter, .prefooter__cta, .integrations-block-precontent, .site > .wp-block-button, .pricing-block-container, .wp-block-cover__inner-container .wp-block-heading, .integrations-block-precontent > *, .wp-block-cover__inner-container > h2, .wp-block-columns:not(.hero-block) .wp-block-column, .integrations-block-outer, .wp-block-cover__image-background, .wp-block-cover__background');

        // items that should fade up and in in sequence
        const stagger_items = gsap.utils.toArray('.entry-content > ul li, .entry-content > ol li, div:not(.facetwp-template)>.teaser, .carousel-slide__inner__content__container .content > *, .wp-block-gallery .wp-block-image, .prefooter li, .pricing-block, .accordion-item');

        // items that should fade up and in randomly in a pattern with eachother
        const randomized_items = gsap.utils.toArray('.integration-item');



        // fadeIn.forEach(animatedElement => {
        //     gsap.from(animatedElement, {
        //         duration: .6,
        //         delay: 0.1,
        //         opacity: 0,
        //         ease: "ease-in",
        //         autoAlpha: 0,
        //         scrollTrigger: {
        //             trigger: animatedElement,
        //             start: 'top 90%', //start: 'top 80%'
        //         },

        //     });
        // });

        scrollTrigger.batch(stagger_items, {
            // batchMax: 3,
            onEnter: elements => {
                gsap.from(elements, {
                    opacity: 0,
                    y: 50,
                    autoAlpha: 0,
                    stagger: 0.175
                });
            },
            once: true
        });

        fadeUpIn.forEach(animatedElement => {
            gsap.from(animatedElement, {
                duration: .6,
                delay: 0.1,
                opacity: 0,
                y: 50,
                ease: "ease-in",
                autoAlpha: 0,
                scrollTrigger: {
                    trigger: animatedElement,
                    start: 'top 99%', //start: 'top 80%'
                },
                clearProps: "transform"

            });
        });

        // items that should fade up and in randomly in a pattern with eachother
        randomized_items.forEach(animatedElement => {
            gsap.from(animatedElement, {
                duration: .6,
                delay: "random(0, 1)",
                opacity: 0,
                y: 50,
                ease: "ease-in",
                autoAlpha: 0,
                stagger: .1,
                scrollTrigger: {
                    trigger: animatedElement,
                    start: 'top 99%', //start: 'top 80%'
                }
            });
        });





        const revealDraw = gsap.utils.toArray('.underline');
        revealDraw.forEach(animatedElement => {
            gsap.to(animatedElement, {
                scrollTrigger: {
                    trigger: animatedElement,
                    start: 'top 99%', //start: 'top 80%'
                    end: 'bottom 20%',
                    markers: false,
                    onToggle: (isActive) => {
                        if (isActive) {
                            //console.log(animatedElement);
                            animatedElement.classList.remove('hidden');
                        }
                    }

                },


            });
        });

        const countables = gsap.utils.toArray(".countable");
        countables.forEach(countable => {
            // let total = $(countable).attr('data-val');
            // let duration = total > 200 ? total / 20 : total / 10;
            gsap.from(countable, {
                textContent: 0,
                duration: 1.5,
                ease: "linear",
                snap: { textContent: 1 },
                stagger: .4,
                // stagger: {
                //     each: .4,
                //     onUpdate: function () {
                //         this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent));
                //     },
                // },
                scrollTrigger: {
                    trigger: countable,
                    start: 'top 90%', //start: 'top 80%'
                }
            });
        });


    }
    // only animate on pages, not on single post detail pages or archive pages

    if (!$('body').hasClass('single') && !$('body').hasClass('archive-no-animate')) {
        //console.log('animate');
        animate();
    }
    // animate();

 
   
});
